import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

export const CONFIGURE_CELEBRATIONS_ELEMENT_ID = 'configureCelebrationsRoute'

const ConfigureCelebrationsRoute = lazyWithRetries(() => import('.'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.admin.configureCelebrations(':tab?'),
    element: (
      <StandardPageLayout
        elementId={CONFIGURE_CELEBRATIONS_ELEMENT_ID}
        maxWidth={900}
        title={<T _str="Celebrations" />}>
        <Suspense fallback={<RouteLoading />}>
          <ConfigureCelebrationsRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
